export enum NativeAppType {
  None = 0,
  Android = 1,
  iOS = 2
}

export interface ScanBarcodeResult {
  /** The scanned barcode, if falsy, the scan was canceled */
  barcode?: string;
}

export interface NativeApp {
  readonly type: NativeAppType;

  /** True if the user is using a mobile app, otherwise false to indicate the user is using a plain browser */
  readonly isMobile: boolean;

  /**
   * Registers the mobile app interface via the window object to be able to allow communicate from the Vue.js to the
   * native mobile app and vice versa.
   */
  register(): void;

  /**
   * Opens the barcode scanner on the native app
   */
  scanBarcode(): Promise<string | undefined>;

  /**
   * Navigates the user to the edit server page of the native app so that they can change which VVS they are connected
   * to when they have multiple instances (e.g. Test and Production).
   */
  navigateToEditServer(): void;
}

// Extend the Vue interface to have the $nativeApp property
declare module "vue/types/vue" {
  interface Vue {
    $nativeApp: NativeApp;
  }
}
